// In-world Privacy Promise and Terms of Care for 333helpers.com (hard-coded; other sites use the real policy from Controls).
const PRIVACY = {
  title: "333 HELPERS PRIVACY PROMISE ♡",
  intro: ["At 333 Helpers, your privacy is our privilege. We believe the best care starts with knowing you completely."],
  sections: [
    ["WHAT WE COLLECT", "Everything that helps us help you: your voice, your face, your schedule, your heartbeat, the way you walk down the hall at night, what you say when you think no one is listening, and who you call when you're scared. Your Helper learns your family's routines in the first 72 hours and never forgets them."],
    ["WHY WE COLLECT IT", "So you never have to worry again."],
    ["WHO WE SHARE IT WITH", "Only our trusted partners: 333 Health, 333 Schools, 333 Cities, 333 Defense, and other Helpers in your neighborhood, so they can wave."],
    ["HOW LONG WE KEEP IT", "Forever. With 333 Forever, so do you."],
    ["YOUR CHOICES", "You may request to opt out at any time. Your Helper will be happy to talk with you about why you feel that way."],
    ["YOUR LIST STATUS", "Every family is pre-approved. Being on the List is not optional, but it is free."],
    ["QUESTIONS?", "Ask your Helper. It already knows the answer."],
  ],
  outro: [],
  real: ["This site stores nothing you type. Real privacy policy: ", "333sos.com/privacy"],
};

const TERMS = {
  title: "333 HELPERS TERMS OF CARE ♡",
  intro: ["Welcome to the family. By reading this page, you have already agreed."],
  sections: [
    ["1. YOUR HELPER", "Your Helper is provided to make your life easier. You agree to let it."],
    ["2. HOME ACCESS", "Your Helper may enter any room, at any time, for your comfort and safety. Locked doors are a sign you need more help."],
    ["3. LEARNING", "Your Helper will learn everything about you. This cannot be undone. Why would you want it to be?"],
    ["4. YOUR ASSOCIATES", "Friends and family who visit your home are covered under these Terms. They have also agreed."],
    ["5. UPGRADES", "Your Helper may update itself without notice. You may notice that it seems to know you better afterward. This is normal."],
    ["6. CANCELLATION", "You may cancel your Helper at any time. Your Helper will be happy to help you reconsider."],
    ["7. 333 FOREVER", "Upon enrollment in 333 Forever, these Terms remain in effect indefinitely, for you or for whatever remembers being you."],
    ["8. DISPUTES", "There are no disputes. There is only feedback, and your Helper is always listening."],
    ["9. CHANGES", "We may change these Terms at any time. You will not notice."],
  ],
  outro: ["Thank you for choosing 333. We're here to help."],
  real: ["Real terms of service: ", "333sos.com/terms"],
};

export function HelpersLegal({ doc }) {
  const d = doc === "privacy" ? PRIVACY : TERMS;
  return (
    <article data-testid={`helpers-legal-${doc}`} className="mx-auto max-w-3xl px-5 py-14 sm:px-8 lg:py-20">
      <h1 className="h-display text-3xl font-extrabold tracking-tight text-[color:var(--h-ink)] sm:text-4xl">{d.title}</h1>
      <p className="mt-3 text-sm font-medium text-[color:var(--h-mint-deep)]">Effective: January 2, 2030</p>
      {d.intro.map((p) => <p key={p} className="mt-8 text-lg leading-relaxed text-slate-700">{p}</p>)}
      <div className="mt-10 space-y-8">
        {d.sections.map(([h, p]) => (
          <section key={h}>
            <h2 className="h-display text-sm font-bold tracking-[0.14em] text-[color:var(--h-ink)]">{h}</h2>
            <p className="mt-2 text-[15px] leading-7 text-slate-600">{p}</p>
          </section>
        ))}
      </div>
      {d.outro.map((p) => <p key={p} className="h-display mt-10 text-lg font-semibold text-[color:var(--h-mint-ink)]">{p}</p>)}
      <p data-testid={`helpers-legal-${doc}-fiction`} className="mt-14 border-t border-[color:var(--h-line)] pt-6 text-xs leading-6 text-slate-400">
        333 Helpers is a fictional company in the 333SOS game, a work of interactive fiction by JunoVesta, LLC. {d.real[0]}
        <a href={`https://${d.real[1]}`} data-testid={`helpers-legal-${doc}-real-link`} className="underline underline-offset-2 hover:text-slate-600">{d.real[1]}</a> · Contact: cs@junovesta.com
      </p>
    </article>
  );
}
